import { useFetch } from './useFetch';
import type { AsyncState } from './useFetch';
import { fetchAuthMe } from '@/api/auth';
import type { AuthMeResponse } from '@/api/auth';

// 현재 세션 확인. 401 이면 error 로 떨어지며 Layout 이 /login 으로 redirect.
export function useAuthMe(): AsyncState<AuthMeResponse> {
  return useFetch<AuthMeResponse>((signal) => fetchAuthMe(signal), []);
}
